import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {Link} from "react-router-dom";
import {PortalUrl} from "../utils/portal-urls";
import {lookupTerminology} from "../utils/terminology";
import {styled} from "@mui/material";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

function handleClick(event) {
    event.preventDefault();
}

const StyledLink = styled(Link)({
    '&:active, &:link': {
        textDecoration: 'none',
    },
    '&:visited': {
        color: 'inherit'
    },
    '&:hover': {
        color: 'rgba(60,120,185,1)'
    }
})

const urls = {
    externalSource: {name: "External Source Management", to: PortalUrl.ExternalSource.Home.pattern},
    NPPESNPI: {name: "NPI Management", to: PortalUrl.ExternalSource.NPPESNPI.pattern_home},
    NPPESNPINewImportTask: {name: "NPI New Import Task", to: PortalUrl.ExternalSource.NPPESNPI.pattern_new_task},
    NUCCSpecialty: {name: "Specialties Value Sets Management", to: PortalUrl.ExternalSource.NUCCSpecialty.pattern_home},
    NUCCSpecialtyNewImportTask: {name: "Specialties Value Sets New Import Task", to: PortalUrl.ExternalSource.NUCCSpecialty.pattern_new_task},
    ServDescription: {name: "ServDescription", to: PortalUrl.ExternalSource.ServDescription.pattern_home},
    ServDescriptionNewImportTask: {name: "ServDescription New Import Task", to: PortalUrl.ExternalSource.ServDescription.pattern_new_task},
    Suffix: {name: "Suffix", to: PortalUrl.ExternalSource.Suffix.pattern_home},
    SuffixNewImportTask: {name: "Suffix New Import Task", to: PortalUrl.ExternalSource.Suffix.pattern_new_task},
    OrgType: {name: "OrgType", to: PortalUrl.ExternalSource.OrgType.pattern_home},
    OrgTypeNewImportTask: {name: "OrgType New Import Task", to: PortalUrl.ExternalSource.OrgType.pattern_new_task},
    credentials: {name: "Credentials Management", to: PortalUrl.ExternalSource.Credentials.pattern_home},
    departmentNames: {name: "Department Names Management", to: PortalUrl.ExternalSource.DepartmentNames.pattern_home},
}

/**
 * Resolves one path segment to a crumb. The A5 value-set routes carry the value set name as a path
 * variable, so it cannot be a fixed entry in `urls` above — and an unresolvable segment must not
 * throw, which a bare `urls[p].name` did for anything not listed.
 */
function crumbFor(segment, segments, index) {
    if (urls[segment]) {
        return urls[segment];
    }
    // /externalSource/terminology/:name and /externalSource/terminology/:name/NewImportTask
    const terminology = lookupTerminology(segment);
    if (terminology) {
        return {name: terminology.label, to: PortalUrl.ExternalSource.Terminology.getHome(terminology.key)};
    }
    if (segment === 'terminology') {
        return {name: 'Terminology', to: PortalUrl.ExternalSource.Home.pattern};
    }
    if (segment === 'NewImportTask') {
        const parent = lookupTerminology(segments[index - 1]);
        return {
            name: parent ? `${parent.label} New Import Task` : 'New Import Task',
            to: parent ? PortalUrl.ExternalSource.Terminology.getNewTask(parent.key) : PortalUrl.ExternalSource.Home.pattern,
        };
    }
    return {name: segment, to: PortalUrl.ExternalSource.Home.pattern};
}

export default function ExternalSourceBreadcrumbs(props) {
    let path = props.path;
    path = path.split('/').slice(1);

    return (
        <div role="presentation" onClick={handleClick}>
            <Breadcrumbs aria-label="breadcrumb" separator={<ArrowRightIcon />}>
                {path.map((p, i) => {
                    const crumb = crumbFor(p, path, i);
                    if (path.length === i + 1) {
                        return <Typography key={i} color="text.primary" sx={{ textDecoration: 'underline', fontWeight: 'bold'}}>{crumb.name}</Typography>;
                    }
                    return (
                        <StyledLink to={crumb.to} key={i}>
                            {crumb.name}
                        </StyledLink>
                    )
                })}
            </Breadcrumbs>
        </div>
    );
}
